// @ts-nocheck
import { getIsCommerceWebsite } from "@store/Framework/Store/Context/ContextSelectors";
import { useSelector } from "react-redux";

export const useIsCommerceWebsite = () => useSelector(getIsCommerceWebsite);
